<div class="notifications-panel" role="dialog" aria-label="Notificaciones">
  <div class="notifications-panel__header" *ngIf="hasContent">
    <h3 class="notifications-panel__heading t-16-700-primary">Notificaciones</h3>
    <button
      type="button"
      class="notifications-panel__mark-all"
      [disabled]="!hasUnread"
      (click)="onMarkAllAsReadClick()"
    >
      Marcar como leído
    </button>
  </div>

  <div *ngIf="hasError" class="notifications-panel__state" role="alert">
    <img
      src="assets/icons/ico_bell_error.svg"
      width="132"
      height="132"
      alt=""
      class="notifications-panel__state-icon"
    />
    <h4 class="notifications-panel__state-title t-16-700-primary">
      No pudimos cargar las notificaciones
    </h4>
    <p class="notifications-panel__state-message t-14-400-dark">
      Ocurrió un problema al obtener la información. Inténtalo nuevamente en
      unos momentos.
    </p>
  </div>

  <div *ngIf="isEmpty" class="notifications-panel__state">
    <img
      src="assets/icons/ico_bell_check.svg"
      width="132"
      height="132"
      alt=""
      class="notifications-panel__state-icon"
    />
    <h4 class="notifications-panel__state-title t-16-700-primary">
      ¡Todo al día!
    </h4>
    <p class="notifications-panel__state-message t-14-400-dark">
      Por ahora no tienes notificaciones por revisar.
    </p>
  </div>

  <ul *ngIf="hasContent" #list class="notifications-panel__list">
    <li
      *ngFor="let notification of notifications; trackBy: trackById"
      class="notifications-panel__item"
      [class.is-read]="notification.isRead"
      (click)="onNotificationClick(notification)"
    >
      <div class="notifications-panel__content">
        <p class="notifications-panel__title t-12-600-dark-16">
          {{ notification.title }}
        </p>
        <p class="notifications-panel__message t-12-500-light-dark">
          {{ notification.message }}
        </p>
        <p
          *ngIf="notification.createAt"
          class="notifications-panel__time t-10-400-tab-inactive"
        >
          {{ notification.createAt | timeAgo }}
        </p>
      </div>
      <span
        *ngIf="!notification.isRead"
        class="notifications-panel__status"
        aria-label="Nueva"
      ></span>
    </li>
  </ul>

  <button
    *ngIf="hasMore && hasContent"
    type="button"
    class="notifications-panel__footer"
    (click)="onViewPreviousClick()"
  >
    <span>Ver notificaciones anteriores</span>
    <img
      src="assets/icons/ico_arrow_green_right.svg"
      width="12"
      height="8"
      alt=""
    />
  </button>
</div>
